/*
* 有話要說
*/ 
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

import { Form, FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';

// @mui
import {
  Box,
  Button, ButtonBase,
  Card, CardActions,
  CardContent,
  CardHeader,
  Divider,
  Drawer, FormHelperText, List, ListItem, ListItemIcon, ListItemText, MenuItem,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import { alpha, styled, useTheme } from '@mui/material/styles';
import { LoadingButton } from '@mui/lab';

import {
  SvgChatFill,
  SvgChevronDownFill,
  SvgChevronUpFill,
  SvgCloseFill, SvgCUserFill, SvgDeleteFill, SvgEmailFill, SvgMobileFill,
  SvgSuccessFill,
  SvgUserFill,
} from '../../SvgIcons';
import FileIcon from '../../file/FileIcon';
import { toastError, toastSuccess } from '../../toastify';
import { queryFeedbackList, toggleFeedbackDrawer, toggleFeedbackListDrawer } from '../../../store/actions/feebackActions';
import { getAssetsUrl, getPictureUrl } from '../../../utils/@helper/file.helper';
import { getFileExtension } from '../../../utils/utils';
import { useRouter } from '../../../hooks/useRoutes';
import { getStorage } from '../../../utils/storage';

import { SimFormControl, SimFormLabel, SimFormSelect } from '../../Bootstrap';
import { ACCESS_TOKEN, FILE_EXTENSION, WEBSITE_ID } from '../../../store/types';
import { createCommentItem, querySensitiveKeyWorks, uploadFiles } from '../../../_db/api.service';
import { queryUnreadNotificationTotal } from '../../../store/actions/slices/notificationActions';
import Feedback from '.';






const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

function InputFileUpload({
  variant = "contained",
  multiple = false,
  iconColor = "#204ACE",
  onChange,
  ...others
}) {
  return (
    <Button
      component="label"
      role={undefined}
      variant={variant}
      tabIndex={-1}
      startIcon={
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" color={iconColor} fill={iconColor}>
          <path d="M10.0539 9.15521C9.86958 9.32494 9.62835 9.41924 9.37791 9.41949L9.38191 9.41749C9.18035 9.41771 8.98343 9.35697 8.81696 9.2432C8.6505 9.12943 8.52225 8.96795 8.44906 8.77995C8.37586 8.59195 8.36114 8.3862 8.40679 8.18967C8.45245 7.99314 8.55635 7.815 8.7049 7.67863L11.3299 5.26404C11.3724 5.23302 11.4176 5.20589 11.4649 5.18296C11.5171 5.14363 11.5735 5.11006 11.6329 5.08284C11.6938 5.06138 11.7569 5.04628 11.8209 5.0378C11.8815 5.02253 11.9435 5.01314 12.0059 5.00977C12.0694 5.01298 12.1324 5.02272 12.1939 5.0388C12.2569 5.04695 12.3189 5.0617 12.3789 5.08284C12.4791 5.14359 12.5791 5.20465 12.6789 5.26604L15.3039 7.68063C15.4992 7.86024 15.6153 8.11017 15.6265 8.37545C15.6378 8.64072 15.5433 8.89961 15.3639 9.09515C15.1845 9.29069 14.9348 9.40687 14.6698 9.41813C14.4048 9.42939 14.1462 9.33483 13.9509 9.15521L13.0019 8.28328V14.0124C13.0019 14.2779 12.8965 14.5325 12.709 14.7203C12.5215 14.908 12.2671 15.0135 12.0019 15.0135C11.7367 15.0135 11.4823 14.908 11.2948 14.7203C11.1073 14.5325 11.0019 14.2779 11.0019 14.0124V8.28328L10.0539 9.15521Z" />
          <path d="M6.00391 17.0076H18.0039C18.2691 17.0076 18.5235 17.1131 18.711 17.3008C18.8986 17.4886 19.0039 17.7432 19.0039 18.0087C19.0039 18.2742 18.8986 18.5288 18.711 18.7166C18.5235 18.9043 18.2691 19.0098 18.0039 19.0098H6.00391C5.73869 19.0098 5.48434 18.9043 5.2968 18.7166C5.10926 18.5288 5.00391 18.2742 5.00391 18.0087C5.00391 17.7432 5.10926 17.4886 5.2968 17.3008C5.48434 17.1131 5.73869 17.0076 6.00391 17.0076Z" />
        </svg>
      }
    >
      上傳附件
      <VisuallyHiddenInput
        type="file"
        onChange={(event) => { onChange(event, event.target.files);  event.target.value = null}}
        multiple={multiple}
        { ...others }
      />
    </Button>
  );
};

const DescriptionItem = ({ children }) => {
  return (
    <Box display={'grid'} gridTemplateColumns={'96px 1fr'} gap={1} alignItems={'center'}>
      { children }
    </Box>
  )
};

const DescriptionLabel = ({ children }) => {
  return (
    <Typography component={'span'} variant={'subtitle1'} fontWeight={700} color={'text.secondary'} display={'flex'} alignItems={'center'} gap={1}>
      { children }
    </Typography>
  )
};

const DescriptionValue = ({ children }) => {
  return (
    <Typography component={'span'} variant={'body1'}>
      { children }
    </Typography>
  )
};

const SelectChevronIcon = (props) => {
  return (
    <Box position={'absolute'} right={7} top={'calc(50% - .8em)'} display={'flex'} alignItems={'center'}>
      { props?.className?.includes('MuiSelect-iconOpen') ? <SvgChevronUpFill size={24}  /> : <SvgChevronDownFill size={24} /> }
    </Box>
  )
}

// const StyledTooltip = 

// 有話要說
const FeedbackDrawer = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const theme = useTheme();

    const { onIcivetAuthorize, onSessionLogin } = useRouter();

    const exist_token = getStorage(ACCESS_TOKEN);

    const { account: { profile, worker, serviceSector, website }, share: { factoryOptions }, feedback } = useSelector(state => state);
  
    const [filelist, setFilelist] = useState([]);

    const validationSchema = Yup.object().shape({
      factoryId: Yup.string().required('必填欄位！'), // '必填欄位！'
      createName: Yup.string().required('必填欄位！'), // '必填欄位！'
      messageContent: Yup.string().required('必填欄位！'),
      messageTitle: Yup.string().required('必填欄位！'),
      messageType: Yup.string().required('必填欄位！'),
      phone: Yup.string().required('必填欄位！'),
      area_id: Yup.string().required('必填欄位！'),
    });
  
    const formik = useFormik({
      enableReinitialize: true,
      initialValues: {
        createName: profile?.realname,
        phone: profile?.phone,
        factoryId: "",
        messageContent: ``,
        messageTitle: ``,
        messageType: "",
        area_id: website?.selected?.id || window.sessionStorage.getItem(WEBSITE_ID),
        filePath: "",
      },
      validationSchema,
      onSubmit: async (
        values,
        { setErrors, setStatus, setSubmitting, resetForm }
      ) => {
        const response = await querySensitiveKeyWorks();
        if(response?.success) {
          const isSubmit = !response?.result.some(item => values?.messageContent.includes(item));
          if(isSubmit) {
            
            const { success, message } = await createCommentItem({ ...values, filePath: String(_.map(filelist, f => f.filePath)) });
            toastSuccess(
              message, 
              'top-center', 
              (<Typography variant='body1' fontWeight={700} color={theme.palette.color.primaryBlue3} mx={1} onClick={() => dispatch(toggleFeedbackListDrawer(true))}>前往查看</Typography>)
            );
            await setStatus({ success: true });
            await setSubmitting(false);
            await dispatch(toggleFeedbackDrawer(false));
            await dispatch(queryFeedbackList({}));
            await dispatch(queryUnreadNotificationTotal());
            await resetForm();
          } else {
            toastError(`抱歉！不良信息無法提交`)
          }
        } else {
          toastError(response?.message)
        };
      }
    });
  
    
    // 上傳文件
    const handleChangeFiles = async (event, files) => {

      console.log('files', files)
      
      // 检查文件格式和大小
      // const allowedTypes = ['application/pdf', 'image/gif', 'application/msword', 'application/zip', 'image/jpeg', 'image/png', 'application/vnd.rar', 'application/vnd.ms-excel'];
      // const totalSize = files?.reduce((acc, file) => {
      //   if (!allowedTypes.includes(file.type)) {
      //       alert(`文件 ${file.name} 的格式不支持`);
      //   }
      //   return file.size + acc
      // }, 0);

      // 检查总大小是否超过 2MB
      if (files?.length && _.some(Array.from(files), f => f?.size > 2 * 1024 * 1024)) {
         toastError(`文件大小不能超过 2MB`);
         return;
      };

       /* eslint-enable no-await-in-loop */
       // eslint-disable-next-line no-plusplus
      for (let i = 0; i < files?.length; i++) {
        const formData = new FormData();
        const file = files[i];

        

        formData.append('file', file);
        formData.append('biz', 'temp');
        
        uploadFiles(formData).then(({ success, message }) => {
          if(success) {
            setFilelist((records) => [...records, {name: file?.name, type: getFileExtension(file?.name), size: (file?.size / 1024)?.toFixed(1), filePath: message}]);
          } else {
            toastError(message);
          };
        });
      };
    };

    // 刪除文件
    const handleDeleteFile = async (file) => {
      formik.setFieldValue('filePath', null, true);
      setFilelist(_.filter(filelist, f => ![file?.filePath].includes(f?.filePath)));
    };
  
  
    const toggleDrawer = (visible) => (event) => {
      setFilelist([]);
      formik.resetForm();
      if(!exist_token) {
        onSessionLogin();
        return;
      };
      dispatch(toggleFeedbackDrawer(visible));
    };
  
    const { values, errors, touched, isSubmitting, handleSubmit, getFieldProps } = formik;
  
    return (
      <div>
        <Box sx={{ ...theme.typography.hoverPrimaryLeftline2px }}>
          <Typography onClick={toggleDrawer(true)} className={'Sim-question-menus-text'} display={'flex'} gap={0.5} alignItems={'center'} py={1} pl={1} pr={1.5} whiteSpace={'nowrap'} variant={'subtitle1'} fontWeight={700}>
            <SvgChatFill />
            {/* 有話要說 */}
            {t('cgam.speak.up')}
          </Typography>
        </Box>
        <Drawer
          variant={'temporary'}
          anchor={'right'}
          open={Boolean(feedback?.isOpenFeedbackForm)}
          // onClose={toggleDrawer(false)}
        >
          <Card sx={{ width: 516, minHeight: '100%', overflow: 'visible', display: 'flex', flexDirection: 'column' }}>
            <CardHeader
              atrr-title={'有話要說'}
              title={t('有話要說')}
              action={<Box onClick={toggleDrawer(false)} sx={{ cursor: 'pointer' }}><SvgCloseFill color={'text.primary'} /></Box>}
              sx={{
                py: 1,
                pl: 3,
                pr: 2,
                borderBottom: '1px solid #CCC',
                '& .MuiCardHeader-action': {
                  m: 0,
                  lineHeight: 0
                }
              }}
            />
            <CardContent sx={{ py: 1, backgroundColor: '#EBF4FF' }}>
              <Box position={'relative'} pl={3}>
                <Box width={20} height={20} position={'absolute'} top={0} left={0}>
                  <Box
                    component={'img'}
                    width={'100%'}
                    src={`${getAssetsUrl('images/smile-00.png')}`}
                  />
                </Box>
                <Typography variant={'body1'}>
                  我們非常重視您的意見和反饋，以便改善服務內容，提供更好的使用體驗。
                </Typography>
              </Box>
            </CardContent>

            <CardContent>
              <Stack spacing={3}>
                <Box>
                  <Typography variant={'h6'} mb={2} sx={{ ...theme.typography.leftLine, paddingBottom: 0.75 }}>申請人資訊</Typography>
                  <Stack spacing={1}>
                    <DescriptionItem>
                      <DescriptionLabel>
                        <SvgUserFill color={theme.palette.text.secondary} />
                        姓名
                      </DescriptionLabel>
                      <DescriptionValue>
                        { profile?.realname } | { worker?.workNo }
                      </DescriptionValue>
                    </DescriptionItem>
                    <DescriptionItem>
                      <DescriptionLabel>
                        <SvgMobileFill color={theme.palette.text.disabled} />
                        電話
                      </DescriptionLabel>
                      <DescriptionValue>
                        { profile?.phone || '--' }
                      </DescriptionValue>
                    </DescriptionItem>
                    <DescriptionItem>
                      <DescriptionLabel>
                        <SvgEmailFill color={theme.palette.text.disabled} />
                        {/* 郵箱 */}
                        { t('ese.email') }
                      </DescriptionLabel>
                      <DescriptionValue>
                        { profile?.email || '--' }
                      </DescriptionValue>
                    </DescriptionItem>
                    <DescriptionItem>
                      <DescriptionLabel>
                        <SvgCUserFill color={theme.palette.text.disabled} />
                        所屬法人
                      </DescriptionLabel>
                      <DescriptionValue>
                        { worker?.companyName || '--' }
                      </DescriptionValue>
                    </DescriptionItem>
                  </Stack>
                </Box>
  
                <Divider />
  
                <Box>
                  <Typography variant={'h6'} mb={2} sx={{ ...theme.typography.leftLine, paddingBottom: 0.75 }}>問題描述</Typography>
                  <FormikProvider value={formik}>
                    <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                      <Stack spacing={3} sx={{ pt: 1 }}>
                        <SimFormControl required variant="standard">
                          <SimFormLabel shrink htmlFor="factory-signle-select">
                            廠區
                          </SimFormLabel>
                          <SimFormSelect
                            id="factory-signle-select"
                            label-id="factory-signle-select-label"
                            required
                            displayEmpty
                            size={'small'}
                            aria-label="廠區"
                            placeholder='選擇內容'
                            variant="outlined"
                            renderValue={(selected) => {
                              if (selected?.length === 0) {
                                return <Typography variant={'body1'} color={theme.palette.text.disabled}>請選擇廠區</Typography>;
                              }
                              return _.find(factoryOptions, item => item.id === selected)?.factoryName;
                            }}
                            {...getFieldProps('factoryId')}
                            error={Boolean(touched.factoryId && errors.factoryId)}
                          >
                            {_.map(factoryOptions, item => (
                              <MenuItem key={item.id} value={item.id}>
                                <ListItemText primary={item?.factoryName} sx={{ my: 0 }} />
                              </MenuItem>
                            ))}
                          </SimFormSelect>
                          <FormHelperText error>{(errors.factoryId && touched.factoryId) && errors.factoryId}</FormHelperText>
                        </SimFormControl>

                        <SimFormControl required variant="standard">
                          <SimFormLabel shrink htmlFor="type-signle-select">
                            服務類別
                          </SimFormLabel>
                          <SimFormSelect
                            id="type-signle-select"
                            label-id="type-signle-select-label"
                            required
                            displayEmpty
                            size={'small'}
                            aria-label="服務類別"
                            variant="outlined"
                            renderValue={(selected) => {
                              if (selected?.length === 0) {
                                return <Typography variant={'body1'} color={theme.palette.text.disabled}>請選擇服務類別</Typography>;
                              }
                              return _.find(serviceSector?.list, item => item.contentCode === selected)?.label;
                            }}
                            {...getFieldProps('messageType')}
                            error={Boolean(touched.messageType && errors.messageType)}
                          >
                            {_.map(serviceSector?.list, item => (
                              <MenuItem key={item.contentCode} value={item?.contentCode}>
                                <ListItemText primary={item?.label} sx={{ my: 0 }} />
                              </MenuItem>
                            ))}
                          </SimFormSelect>
                          <FormHelperText error>{(errors.messageType && touched.messageType) && errors.messageType}</FormHelperText>
                        </SimFormControl>

                        <SimFormControl required variant="standard">
                          <SimFormLabel shrink htmlFor="title-signle-select">
                            標題
                          </SimFormLabel>
                          <TextField
                            id="title-signle-select"
                            label-id="title-signle-select-label"
                            fullWidth
                            size={'small'}
                            maxLength={100}
                            inputProps={{ maxLength: 100 }}
                            placeholder='請輸入內容'
                            {...getFieldProps('messageTitle')}
                            error={Boolean(touched.messageTitle && errors.messageTitle)}
                            helperText={touched.messageTitle && errors.messageTitle}
                          />
                        </SimFormControl>


                        <SimFormControl required variant="standard">
                          <SimFormLabel shrink htmlFor="description-signle-select">
                            問題描述
                          </SimFormLabel>
                          <TextField
                            fullWidth
                            multiline
                            rows={4}
                            maxLength={150}
                            inputProps={{ maxLength: 150 }}
                            placeholder='請輸入內容'
                            {...getFieldProps('messageContent')}
                            error={Boolean(touched.messageContent && errors.messageContent)}
                            helperText={touched.messageContent && errors.messageContent}
                          />
                          <Stack
                            direction={'row'}
                            alignItems={'center'}
                            position={'absolute'}
                            right={4}
                            top={120}
                          >
                            <Typography variant='body2' color={values?.messageContent && (Number(values?.messageContent?.length >= 0) ) ? 'color.secondaryMain' : 'text.secondary'}>150/{values?.messageContent ? 150 - values?.messageContent?.length : 150}</Typography>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path d="M17.7054 11.8399C17.5187 11.6526 17.2654 11.5474 17.0013 11.5474C16.7372 11.5474 16.4839 11.6526 16.2972 11.8399L11.8742 16.2825C11.7791 16.3746 11.7032 16.4848 11.651 16.6067C11.5988 16.7286 11.5713 16.8597 11.5702 16.9923C11.569 17.125 11.5943 17.2565 11.6443 17.3793C11.6944 17.5021 11.7684 17.6136 11.8619 17.7074C11.9554 17.8012 12.0666 17.8754 12.189 17.9256C12.3114 17.9759 12.4425 18.0011 12.5748 18C12.707 17.9988 12.8377 17.9713 12.9592 17.9189C13.0807 17.8665 13.1906 17.7904 13.2825 17.695L17.7084 13.2555C17.8011 13.1625 17.8746 13.052 17.9246 12.9305C17.9747 12.8089 18.0003 12.6786 18 12.5471C17.9997 12.4156 17.9736 12.2854 17.923 12.164C17.8725 12.0427 17.7985 11.9325 17.7054 11.8399Z" fill="#333333"/>
                              <path d="M17.7054 11.8399C17.5187 11.6526 17.2654 11.5474 17.0013 11.5474C16.7372 11.5474 16.4839 11.6526 16.2972 11.8399L11.8742 16.2825C11.7791 16.3746 11.7032 16.4848 11.651 16.6067C11.5988 16.7286 11.5713 16.8597 11.5702 16.9923C11.569 17.125 11.5943 17.2565 11.6443 17.3793C11.6944 17.5021 11.7684 17.6136 11.8619 17.7074C11.9554 17.8012 12.0666 17.8754 12.189 17.9256C12.3114 17.9759 12.4425 18.0011 12.5748 18C12.707 17.9988 12.8377 17.9713 12.9592 17.9189C13.0807 17.8665 13.1906 17.7904 13.2825 17.695L17.7084 13.2555C17.8011 13.1625 17.8746 13.052 17.9246 12.9305C17.9747 12.8089 18.0003 12.6786 18 12.5471C17.9997 12.4156 17.9736 12.2854 17.923 12.164C17.8725 12.0427 17.7985 11.9325 17.7054 11.8399Z" fill="black" fillOpacity="0.2"/>
                              <path d="M16.6019 6.29249C16.4152 6.10521 16.1619 6 15.8978 6C15.6337 6 15.3804 6.10521 15.1937 6.29249L6.34075 15.1726C6.23799 15.2626 6.15476 15.3728 6.09625 15.4965C6.03773 15.6201 6.00517 15.7545 6.00057 15.8913C5.99597 16.0281 6.01943 16.1643 6.06951 16.2916C6.1196 16.4189 6.19523 16.5346 6.29171 16.6313C6.38819 16.7281 6.50345 16.804 6.63037 16.8542C6.75729 16.9044 6.89315 16.928 7.02951 16.9234C7.16588 16.9188 7.29984 16.8861 7.4231 16.8274C7.54635 16.7687 7.65625 16.6852 7.74601 16.5821L16.5989 7.70207C16.7851 7.51525 16.89 7.26207 16.8905 6.9979C16.8911 6.73374 16.7873 6.4801 16.6019 6.29249Z" fill="#333333"/>
                              <path d="M16.6019 6.29249C16.4152 6.10521 16.1619 6 15.8978 6C15.6337 6 15.3804 6.10521 15.1937 6.29249L6.34075 15.1726C6.23799 15.2626 6.15476 15.3728 6.09625 15.4965C6.03773 15.6201 6.00517 15.7545 6.00057 15.8913C5.99597 16.0281 6.01943 16.1643 6.06951 16.2916C6.1196 16.4189 6.19523 16.5346 6.29171 16.6313C6.38819 16.7281 6.50345 16.804 6.63037 16.8542C6.75729 16.9044 6.89315 16.928 7.02951 16.9234C7.16588 16.9188 7.29984 16.8861 7.4231 16.8274C7.54635 16.7687 7.65625 16.6852 7.74601 16.5821L16.5989 7.70207C16.7851 7.51525 16.89 7.26207 16.8905 6.9979C16.8911 6.73374 16.7873 6.4801 16.6019 6.29249Z" fill="black" fillOpacity="0.2"/>
                            </svg>
                          </Stack>
                        </SimFormControl>


                        <SimFormControl variant="standard">
                          <SimFormLabel shrink htmlFor="description-signle-select">
                            附件
                          </SimFormLabel>
                          <Box>
                            <InputFileUpload
                              multiple
                              variant='outlined'
                              iconColor={theme.palette.color.primaryBlue2}
                              accept=".pdf,.gif,.doc,.jpg,.jpeg,.png,.xls"
                              onChange={(event, files) => handleChangeFiles(event, files)} 
                            />
                            <Typography variant='body2' color={'text.secondary'} mt={1}>
                              文件格式為：pdf,gif,doc,xls,jpg,jpeg 等，每份文件不超過2M。
                            </Typography>
                            <List>
                              {
                                _.map(filelist, (file, index) => (
                                  <ListItem 
                                    key={index}
                                    sx={{
                                      borderRadius: '4px',
                                      border: '1px solid #C3C3C3',
                                      p: 1.5,
                                      mb: 1,
                                    }}
                                  >
                                    <ListItemIcon sx={{ minWidth: 32 }}>
                                      <FileIcon type={file?.type} color={theme.palette.error.main} />
                                    </ListItemIcon>
                                    <ListItemText
                                      disableTypography
                                      sx={{ m: 0 }}
                                      primary={
                                        <Stack component={'span'} direction={'row'} alignItems={'center'}>
                                          <Tooltip
                                            arrow
                                            placement="bottom"
                                            title={
                                              <Typography component={'span'} variant='body2' maxWidth={245} noWrap>{file?.name}</Typography>
                                            }
                                            PopperProps={{
                                              sx: {
                                                borderRadius: 6/6,
                                              },
                                            }}
                                            slotProps={{
                                              popper: {
                                                sx: {},
                                              },
                                              tooltip: {
                                                sx: {
                                                  borderRadius: 6/9,
                                                  p: theme.spacing(1, 1.5),
                                                  boxShadow: '0px 2px 8px 0px rgba(157, 172, 208, 0.25)',
                                                },
                                              }
                                            }}
                                          >
                                            <Typography component={'span'} variant='body2' fontWeight={700} maxWidth={300} noWrap>{file?.type} {file?.name}</Typography>
                                          </Tooltip>
                                          <Divider sx={{ height: 22, alignSelf: 'center', mx: 1.5, my: 0, borderColor: '#C3C3C3' }} orientation="vertical" variant="middle" flexItem />
                                          <Typography component={'span'} variant='body2' color={theme.palette.grey[600]}>{file?.size}KB</Typography>
                                        </Stack>
                                      } 
                                      secondary={
                                        <Stack direction={'row'}>
                                          <SvgSuccessFill size={16} color={theme.palette.color.successMain} />
                                          <Typography variant='caption' color={'color.successMain'}>
                                            上傳成功！
                                          </Typography>
                                        </Stack>
                                      }
                                    />
                                    <Tooltip
                                      arrow
                                      placement="bottom"
                                      title={
                                        <Typography component={'span'} variant='body2' maxWidth={300} noWrap>
                                          預覽{[FILE_EXTENSION.jpeg, FILE_EXTENSION.jpg, FILE_EXTENSION.png, FILE_EXTENSION.gif].includes(file?.type) ? '圖片' : '文檔'}
                                        </Typography>
                                      }
                                      PopperProps={{
                                        sx: {
                                          borderRadius: 6/6,
                                        },
                                      }}
                                      slotProps={{
                                        popper: {
                                          sx: {},
                                        },
                                        tooltip: {
                                          sx: {
                                            borderRadius: 6/9,
                                            p: theme.spacing(1, 1.5),
                                            boxShadow: '0px 2px 8px 0px rgba(157, 172, 208, 0.25)',
                                          },
                                        }
                                      }}
                                    >
                                      {/* {
                                        file?.percent && Number(file?.percent) >= 100 ? (
                                          <Button size='small' onClick={() => window.open(`${getPictureUrl(file?.filePath)}`)} sx={{ minWidth: 0, px: 1.5, borderRadius: '4px' }}>
                                            預覽
                                          </Button>
                                        ) : (
                                          <Typography
                                            variant={'body2'}
                                            fontWeight={700}
                                            paddingBlock={0.625}
                                            paddingInline={1.5}
                                            component={ButtonBase}
                                            color={theme.palette.color.primaryBlue2}
                                          >
                                            {file?.percent}%
                                          </Typography>
                                        )
                                      } */}
                                      <Button size='small' onClick={() => window.open(`${getPictureUrl(file?.filePath)}`)} sx={{ minWidth: 50, px: 1.5, borderRadius: '4px', }}>
                                        預覽
                                      </Button>
                                    </Tooltip>

                                    <Tooltip
                                      arrow
                                      placement="bottom"
                                      title={
                                        <Typography component={'span'} variant='body2' maxWidth={300} noWrap>
                                          刪除{[FILE_EXTENSION.jpeg, FILE_EXTENSION.jpg, FILE_EXTENSION.png, FILE_EXTENSION.gif].includes(file?.type) ? '圖片' : '文檔'}
                                        </Typography>
                                      }
                                      PopperProps={{
                                        sx: {
                                          borderRadius: 6/6,
                                        },
                                      }}
                                      slotProps={{
                                        popper: {
                                          sx: {},
                                        },
                                        tooltip: {
                                          sx: {
                                            borderRadius: 6/9,
                                            p: theme.spacing(1, 1.5),
                                            boxShadow: '0px 2px 8px 0px rgba(157, 172, 208, 0.25)',
                                          },
                                        }
                                      }}
                                    >
                                      {/* <Typography
                                        variant={'body2'}
                                        fontWeight={700}
                                        paddingBlock={0}
                                        paddingInline={1}
                                        component={ButtonBase}
                                        disableRipple
                                        color={theme.palette.color.primaryBlue2}
                                        onClick={() => handleDeleteFile(file)}
                                      >
                                        <SvgDeleteFill />
                                      </Typography> */}
                                      <Button size='small' onClick={() => handleDeleteFile(file)} sx={{ minWidth: 0, borderRadius: '4px' }}>
                                        <SvgDeleteFill />
                                      </Button>
                                    </Tooltip>
                                  </ListItem>
                                ))
                              }
                              
                            </List>
                          </Box>
                        </SimFormControl>
                      </Stack>
                    </Form>
                  </FormikProvider>
                </Box>
              </Stack>
            </CardContent>

            <CardContent sx={{ flexGrow: 1 }} />

            <CardActions sx={{ px: 3, py: 2, justifyContent: 'flex-end', borderTopStyle: 'solid', borderTopWidth: 1, borderTopColor: 'divider' }}>
              <Button
                variant='default'
                onClick={toggleDrawer(false)}
                sx={{
                  height: 40,
                  border: `1px solid #DCDCDC`,
                  px: 3.375,
                  fontSize: 16,
                  fontWeight: 700,
                  color: 'text.secondary'
                }}
              >
                {/* 取消 */}
                { t('ese.cancel') }
              </Button>
              <LoadingButton
                type="submit"
                variant="contained"
                loading={isSubmitting}
                onClick={handleSubmit}
                sx={{
                  height: 40,
                  px: 3.375,
                  fontSize: 16,
                  fontWeight: 700
                }}
              >
                {/* 儲存變更 */}
                { t('確認提交') }
              </LoadingButton>
            </CardActions>
          </Card>
        </Drawer>


        {exist_token && (<Feedback />)}
      </div>
    )
};


export default FeedbackDrawer;